<script lang="ts" setup>
import ParagrahNote from '../../ParagrahNote.vue';
import WhereToConsultCard from '../../WhereToConsult/WhereToConsultCard.vue';
import TotalSavingsImg from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/marriageCost/WhereToConsultCard/04_total_savings.png/04_total_savings.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  imageNumber: number;
}>();
</script>

<template>
  <WhereToConsultCard
    title="結婚費用のための貯金額：平均317.2万円"
    :image-number="imageNumber"
  >
    <PinchImageModal
      :src="TotalSavingsImg"
      alt="結婚費用のための夫婦の貯金総額"
    />
    <p>
      結婚資金のための夫婦の貯金総額は平均317.2万円でした。全国的に見ると、100～400万円の範囲で結婚資金を貯金している夫婦が半数以上を占めています。
    </p>
    <p>
      結婚資金の平均は約523万円であることから、夫婦の貯金だけで結婚資金全額を賄うケースは少なく、ご祝儀や親・親族からの援助などで一部を補填しているカップルが多いと考えられます。
    </p>
    <p>
      将来的に結婚を考えているパートナーがいる方は早めに2人で話し合い、目標額を決めて貯金を始めることが大切です。
    </p>
    <ParagrahNote>
      参照：<NuxtLink
        href="https://souken.zexy.net/data/trend2023/XY_MT23_report_06shutoken.pdf"
        external
        target="_blank"
        >ゼクシィ結婚トレンド調査2023首都圏 全国（推計値）</NuxtLink
      >
    </ParagrahNote>
  </WhereToConsultCard>
</template>

<style lang="scss" module></style>
